import { loginApi } from './axiosClient'

export default {
  checkLogin: data => {
    return loginApi.post(`auth/refresh-token`, data)
  },
}
